// queries/getCertifications.ts
import datoCMSClient from './datoCMSClient';
import { Certification } from '../types';

// Define the Category type to match the component
type Category = 'IT' | 'Water & WasteWater';

// Pass the category as a GraphQL variable ($category) and use it for filtering (filter: {category: {eq: $category}})
const GET_CERTIFICATIONS_BY_CATEGORY = `
  query GetCertifications($category: String!) {
    allCertifications(filter: {category: {eq: $category}}) {
      title
      issuer
      issuedDate
      link
      iconName
    }
  }
`;

// Update the function signature to accept the category
export async function getCertifications(category: Category): Promise<Certification[]> {
  const data = await datoCMSClient.request<{ allCertifications: Certification[] }>(
    GET_CERTIFICATIONS_BY_CATEGORY,
    // Pass the category as a variable
    { category: category }
  );
  return data.allCertifications;
}